import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { TrashIcon } from '../therapyPlanning_2.0/commonComponent/therapy-planning-icons';

type Props = {
  title: string;
  message: string;
  close: any;
  handleSaveBtn?: any;
  button?: {
    saveLabel: string;
    closeLabel: string;
  };
};

function ConfirmationPopupModal({
  handleSaveBtn,
  message,
  title,
  close,
  button = {
    saveLabel: 'Save',
    closeLabel: 'Cancel',
  },
}: Props) {
  return (
    <Box
      p={'12px'}
      minWidth={'600px'}
    >
      <Stack
        flexDirection="row"
        // p={'2rem'}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: '#FEE4E2',
            padding: '4px',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            margin: '16px 4px 0px 16px',
          }}
        >
          <TrashIcon />
        </Stack>
        <Stack>
          <DialogTitle sx={{ padding: '16px 14px 10px 14px ' }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 500,
                lineHeight: 1.5,
                letterSpacing: 0.0075,
                color: 'text.primary',
              }}
            >
              {title}
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: '0px 14px 10px 14px !important' }}>
            <Typography
              sx={{ color: '#6C737F' }}
              variant="body2"
            >
              {message}
            </Typography>
          </DialogContent>
        </Stack>
      </Stack>
      <DialogActions>
        <Button
          autoFocus
          color="inherit"
          onClick={close}
        >
          {button.closeLabel}
        </Button>
        <Button
          autoFocus
          color="error"
          variant="contained"
          onClick={handleSaveBtn}
        >
          {button.saveLabel}
        </Button>
      </DialogActions>
    </Box>
  );
}

export default ConfirmationPopupModal;
